<script>
/**
 * Index
 * @version 1.0.0
 * @since
 */

import { wizardEmitterMixin } from '@/mixins/wizard';
import EzWizard from '@/components/layout/Wizard.vue';
import EzButton from '@/components/ui/Button';
import { mapMutations } from 'vuex';
import steps, {
  DISTRIBUTOR_STEP_1,
  DISTRIBUTOR_STEP_2,
  DISTRIBUTOR_STEP_3,
  DISTRIBUTOR_STEP_4,
} from './steps';

export default {
  mixins: [wizardEmitterMixin],
  components: {
    EzButton,
    EzWizard,
  },
  props: {
    prefilledName: {
      type: String,
    },
  },
  data() {
    return {
      currentStep: 0,
      DISTRIBUTOR_STEP_1,
      DISTRIBUTOR_STEP_2,
      DISTRIBUTOR_STEP_3,
      DISTRIBUTOR_STEP_4,
      nextDisabled: true,
    };
  },
  computed: {
    currentStepComponent() {
      return steps[this.currentStep].component;
    },
    currentStepPageTitle() {
      return steps[this.currentStep].pageTitle;
    },
    currentStepPageInfo() {
      return steps[this.currentStep].pageInfo;
    },
    nextCta() {
      return steps[this.currentStep].nextCta;
    },
    isFirstStep() {
      return this.currentStep === DISTRIBUTOR_STEP_1;
    },
    isLastStep() {
      return this.currentStep === DISTRIBUTOR_STEP_4;
    },
    disableNext() {
      return false;
    },
  },
  methods: {
    ...mapMutations('xero', ['CLEAR_STATE']),
    onWizardExit() {
      this.CLEAR_STATE();
      this.$router.push({ name: 'distributor-integrations' });
    },
    onStepBack(step) {
      if (step !== undefined && step >= DISTRIBUTOR_STEP_1 && step <= DISTRIBUTOR_STEP_4) {
        this.currentStep = step;
        return;
      }

      if (this.currentStep <= DISTRIBUTOR_STEP_1) {
        return;
      }

      this.currentStep -= 1;
    },
    onStepCompleted() {
      if (this.currentStep >= DISTRIBUTOR_STEP_4) {
        return;
      }
      this.nextDisabled = true;
      this.currentStep += 1;
    },
  },
};
</script>
<template>
  <ez-wizard
    :fullWidth="currentStep === DISTRIBUTOR_STEP_2 || currentStep === DISTRIBUTOR_STEP_3"
    @exit="onWizardExit"
    @back="goToPreviousStep">
    <template #title>{{ $t('xero.wizzard.title') }}</template>
    <template #nav>
      <ul>
        <li :class="{
          'ez-step-active': currentStep === DISTRIBUTOR_STEP_1,
          'ez-step-completed': currentStep > DISTRIBUTOR_STEP_1,
        }">
          {{ $t('xero.wizzard.step1.title') }}
        </li>
        <li :class="{
          'ez-step-active': currentStep === DISTRIBUTOR_STEP_2,
          'ez-step-completed': currentStep > DISTRIBUTOR_STEP_2,
        }">
          {{ $t('xero.wizzard.step2.title') }}
        </li>
        <li :class="{
          'ez-step-active': currentStep === DISTRIBUTOR_STEP_3,
          'ez-step-completed': currentStep > DISTRIBUTOR_STEP_3,
        }">
          {{ $t('xero.wizzard.step3.title') }}
        </li>
      </ul>
    </template>
    <template #actions>
      <ez-button
        :disabled="nextDisabled"
        @click="goToNextStep">{{ nextCta }}</ez-button>
    </template>
    <template #prevStep>
      <ez-button
        v-if="currentStep > DISTRIBUTOR_STEP_1 && currentStep < DISTRIBUTOR_STEP_4"
        type="link"
        formType="button"
        @click="goToPreviousStep">
        <font-awesome-icon icon="arrow-left"/>
        <span>Back</span>
      </ez-button>
    </template>
    <template #pageTitle>{{ currentStepPageTitle }}</template>
    <template #pageInfo>{{ currentStepPageInfo }}</template>
    <component
      :prefilledName="prefilledName"
      :is="currentStepComponent"
      @stepCompleted="onStepCompleted"
      @stepBack="onStepBack"></component>
  </ez-wizard>
</template>
<style lang="scss" scoped></style>
